import React from 'react';
// Proceedings book Sales Follow up
const NineteenStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>Dear {client_name ? client_name : `[Client Name]`},</strong>
      </p>

      <p>
        <strong>Proceedings book</strong> for{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>{' '}
        has been finalized, and we have <strong>very few slots left</strong> for
        registrations. This is your chance to secure your spot and get your
        research included in this prestigious publication.
      </p>

      <p>
        Don’t miss out! Register now to secure your place and ensure your work
        is part of the conference proceedings:{' '}
        {registration_link ? (
          <a href={registration_link} target="_blank" rel="noopener noreferrer">
            {registration_link}
          </a>
        ) : (
          `[Registration Link]`
        )}
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default NineteenStepWhatsappTemplate;
